/**
 * Sticky open/closed preference for the live chat pipeline stepper.
 *
 * The live stepper (`PipelineSteps`) starts collapsed by default; whenever the
 * user expands or collapses it, the new state is persisted here so the next
 * turn's stepper starts the same way. This is a per-browser preference — no
 * server round-trip.
 */
const STEPPER_EXPANDED_KEY = "beflow.chat.stepper-expanded";

/**
 * Read the persisted stepper-expanded preference. Defaults to `false`
 * (collapsed) when the key is absent or `localStorage` is unavailable
 * (private mode, quota) — the read never throws.
 */
export function readStepperExpandedPref(): boolean {
  try {
    return window.localStorage.getItem(STEPPER_EXPANDED_KEY) === "true";
  } catch {
    return false;
  }
}

/**
 * Persist the stepper-expanded preference. Storage failures (private mode,
 * quota) are swallowed silently — the in-memory state of the current page
 * still reflects the toggle.
 */
export function writeStepperExpandedPref(expanded: boolean): void {
  try {
    window.localStorage.setItem(STEPPER_EXPANDED_KEY, expanded ? "true" : "false");
  } catch {
    // localStorage unavailable — keep the in-memory state only.
  }
}
